module.exports = __webpack_public_path__ + "img/product_7.15acf9b.webp";